var exports = {
  "vK": "xa9f3555f--f07a58--banner",
  "DD": "xa9f3555f--f07a58--title",
  "Kk": "xa9f3555f--f07a58--icon",
  "Qq": "xa9f3555f--f07a58--text",
  "XI": "xa9f3555f--f07a58--action",
};

module.exports = exports;
